<template>
	<div>
	  	<el-tabs v-model="chooseTab" @tab-change="handleClick" class="p-2">
		  	<el-tab-pane
			    v-for="(item, index) in activitiyLabelTabs"
			    :key="item.name"
			    :label="item.label"
			    :name="item.name"
			  >
			 		<div v-if="filterParams.activity_label == item.name">
					 	<div>
							<div class="list-item d-flex justify-content-between" v-for="coin in coins.data" :key="coin.id">
								<div class="d-flex">
									<div>
										<img src="/static/images/coin.svg">
									</div>
									<div class="ml-2">
										<template v-if="coin.activity_label == 'earned' || coin.activity_label == 'awaiting'">
											<p class="list-item__title" v-if="coin.content.mission == '@InviteeSubs'">{{ t("coins.subscriptionCoins") }}</p>
											<p class="list-item__title" v-else-if="coin.content.mission == '@InviteeSubSubs'">{{ t("coins.subscriptionOfflineCoins") }}</p>
											<p class="list-item__title" v-else-if="coin.content.mission == '@InviteeOrder'">{{ t("coins.orderCoins") }}</p>
											<p class="list-item__title" v-else-if="coin.content.mission == '@InviteeSubOrder'">{{ t("coins.orderOfflineCoins") }}</p>
											<p class="list-item__title" v-else-if="coin.content.mission == '@KolOrder'">{{ t("coins.kolCoins") }}</p>
											<p class="list-item__title" v-else>{{ coin.content.mission }}{{ t("coins.bonus") }}</p>
											<p class="list-item__subtitle text-muted">
												<span v-if="coin.content.mission == '@InviteeSubs'">{{ t("coins.subscriber") }}</span>
												<span v-if="coin.content.mission == '@InviteeSubSubs'">{{ t("coins.subscriber") }}</span>
												<span v-else-if="coin.content.mission == '@InviteeOrder'">{{ t("coins.buyer") }}</span>
												<span v-else-if="coin.content.mission == '@InviteeSubOrder'">{{ t("coins.buyer") }}</span>
												<span v-else-if="coin.content.mission == '@KolOrder'">{{ t("coins.buyer") }}</span>
												<span v-else>{{ coin.content.mission }}</span>
												: {{ coin.content.invitee_user.name }}
												<span> - {{ dateFormat(coin.created_at) }}</span>
											</p>
										</template>

										<template v-if="coin.activity_label == 'used'">
											<p class="list-item__title">{{ t("orders.id") }}: {{ coin.content.order.id }}</p>
											<p class="list-item__subtitle text-muted">
												<span>{{ dateFormat(coin.created_at) }}</span>
											</p>
										</template>
									</div>
								</div>
								<div>
									<span v-if="coin.activity_label == 'used'">-{{ coin.amount }}</span>
									<span v-else>+{{ coin.amount }}</span>
								</div>
							</div>
						</div>
			    	<div v-if="!coins.data.length" class="mt-3 mb-2 text-center">
				      {{ t("global.empty") }}
				    </div>
				    <div v-if="coins.paging" class="card-footer">
				      <!-- Pagination-->
				      <nav class="d-flex justify-content-between pt-2" aria-label="Page navigation">
				        <ul class="pagination">
				          <li class="page-item">
				            <el-button :disabled="coins.paging.before == null" @click="handlePrePage">
				              <i class="czi-arrow-left mr-2"></i>
				              {{ t("paging.prevPage") }}
				            </el-button>
				          </li>
				        </ul>
				        <ul class="pagination">
				            <li class="page-item">
				              <el-button :disabled="coins.paging.after == null" @click="handleNextPage">
				                {{ t("paging.nextPage") }}
				                <i class="czi-arrow-right ml-2"></i>
				              </el-button>
				            </li>
				        </ul>
				      </nav>
				    </div>
				   </div>
		  	</el-tab-pane>
	  	</el-tabs>
	</div>
</template>

<script setup>
import { reactive, ref, onMounted } from 'vue'
import { useI18n } from "vue-i18n"
import { notificationErrors, dateFormat } from "../../utils"
import { _api_getCoinActivities } from "../../api/index.js";

const { t, n, locale } = useI18n()

const activitiyLabelTabs = [
	{"label": t("coins.earnedCoins"), "name": "earned"},
	{"label": t("coins.awaitingCoins"), "name": "awaiting"},
	{"label": t("coins.usedCoins"), "name": "used"},
]

const chooseTab = ref('earned')

const filterParams = reactive({
  limit: 10,
  activity_label: 'earned',
  ending_before: null,
  starting_after: null,
})
const coins = reactive({
  data: [],
  paging: null,
})

const getData = async () => {
  window.fullPageLoading("show")
  try {
    const resp = await _api_getCoinActivities(filterParams)
    coins.data = resp.data
    coins.paging = resp.paging
  } catch (err) {
    notificationErrors(err)
  } finally {
    window.fullPageLoading("hide")
  }
}
const handleClick = () => {
	filterParams.activity_label = chooseTab.value
	getData()
}

const handlePrePage = () => {
  filterParams.ending_before = coins.paging.before
  filterParams.starting_after = null
  getData()
}
const handleNextPage = () => {
  filterParams.ending_before = null
  filterParams.starting_after = coins.paging.after
  getData()
}

onMounted(() => {
  getData()
})
</script>
<style>
	.list-item {
      border-bottom: 1px solid #b2b2b2;
      padding: 1rem 0.5rem;
  }
  .list-item__title {
      font-size: 1.125rem;
      margin-bottom: 0px;
  }
  .list-item__subtitle {
      font-size: .875rem;
      margin-bottom: 0px;
  }
</style>